import { PIN_LOGIN_ON } from 'featureFlags';

// Console: localStorage.setItem('savi.feature.pin', 'true' | 'false'), then reload.
export const PIN_FEATURE_OVERRIDE_KEY = 'savi.feature.pin';

export const isPinFeatureOn = (): boolean => {
  try {
    const override = localStorage.getItem(PIN_FEATURE_OVERRIDE_KEY);
    if (override === 'true') return true;
    if (override === 'false') return false;
  } catch {
    // storage unavailable: fall back to the build-time flag
  }
  return PIN_LOGIN_ON;
};
